/** Data attribute marking popout content whose float window is layered below MUI modals, menus and tooltips. */
export const BELOW_MODALS_ATTRIBUTE = "data-popout-below-modals";
